import { VStack, Checkbox } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../../store/store_context";
import { useEffect } from "react";

const IsReturnAndPaid = observer(() => {
  const { pageStore } = useStores();

  const handleChange = (field) => (e) => {
    pageStore.updateSelectedView({
      ...pageStore.selected_view,
      [field]: e.target.checked,
    });
  };

  const handleChangeSelf = (field, value) => {
    pageStore.updateSelectedView({
      [field]: value,
    });
  };

  useEffect(() => {
    handleChangeSelf("isNotReturn", true);
  }, []);

  return (
    <VStack
      align="start"
      spacing={2}
      bg="#333"
      p={3}
      borderRadius="10px"
      width="250px"
      color="#EEEEEE"
    >
      <Checkbox
        colorScheme="green"
        isChecked={pageStore.selected_view?.isReturn == true || false}
        onChange={handleChange("isReturn")}
      >
        Возвратный счёт
      </Checkbox>
      <Checkbox
        colorScheme="green"
        isChecked={pageStore.isFail}
        onChange={(e) => pageStore.setIsFail(e.target.checked)}
      >
        Проигранные сделки
      </Checkbox>
      <Checkbox
        colorScheme="green"
        isChecked={pageStore.selected_view?.isNotReturn == true || false}
        onChange={handleChange("isNotReturn")}
      >
        Обычный счёт
      </Checkbox>
    </VStack>
  );
});

export default IsReturnAndPaid;